import { FmsApi } from "../fmsapi"
import { type ResponseCancelInicis } from "../models/responsedto"
import BaseController from "./base"

export class PaymentsInicisController extends BaseController {
  constructor(api: FmsApi) {
    super(api, "paymentsInicis")
  }

  public async cancelInicis(params: {
    amount: number
    imp_uid: string
    reason: string
    refund_account: string
    refund_bank: string
    refund_holder: string
    vbank_delete: string
    req_type: string
    vid: number
  }): Promise<ResponseCancelInicis> {
    return await this.callApi("cancelInicis", params)
  }
}
